/**
 * Supplier actions
 */
export enum SupplierActionEnum {
	/**
	 * Set supplier status to active
	 */
	ACTIVATE = 'activate',

	/**
	 * Set supplier status to closed
	 */
	CLOSE = 'close',

	/**
	 * Set supplier status to on hold
	 */
	PUT_ON_HOLD = 'put_on_hold',
}
